module.exports = __webpack_public_path__ + "img/c8cbf4858a9fc65333a7920c5c0a2190.png";


//////////////////
// WEBPACK FOOTER
// ./components/levels/levelPrologue/assets/images/background-sun.png
// module id = 84
// module chunks = 0